import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import AtomAccordion from "@/components/AtomAccordion";
import AtomList from "@/components/AtomList";
var TableInfo = function (_a) {
    var data = _a.data;
    var t = useTranslation().t;
    var tableInfoItems = useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        return [
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.lobbyName"),
                value: data === null || data === void 0 ? void 0 : data.name,
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.lobbyId"),
                value: data === null || data === void 0 ? void 0 : data.lobbyId,
                type: "id",
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.tableName"),
                value: data === null || data === void 0 ? void 0 : data.name,
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.tableId"),
                value: data === null || data === void 0 ? void 0 : data.id,
                type: "id",
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.gameType"),
                value: data === null || data === void 0 ? void 0 : data.type,
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.currency"),
                value: data === null || data === void 0 ? void 0 : data.currency,
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.buyInRange"),
                value: ((_a = data === null || data === void 0 ? void 0 : data.gameConfig) === null || _a === void 0 ? void 0 : _a.minBuyIn) + " - " + ((_b = data === null || data === void 0 ? void 0 : data.gameConfig) === null || _b === void 0 ? void 0 : _b.maxBuyIn),
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.bbsb"),
                value: ((_d = (_c = data === null || data === void 0 ? void 0 : data.gameConfig) === null || _c === void 0 ? void 0 : _c.blinds) === null || _d === void 0 ? void 0 : _d.big) + " - " + ((_f = (_e = data === null || data === void 0 ? void 0 : data.gameConfig) === null || _e === void 0 ? void 0 : _e.blinds) === null || _f === void 0 ? void 0 : _f.small),
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.tableSeat"),
                value: (_g = data === null || data === void 0 ? void 0 : data.gameConfig) === null || _g === void 0 ? void 0 : _g.totalSeats,
            },
        ];
    }, [data, t]);
    return (_jsx(AtomAccordion, { defaultActiveKey: ["tableInfo"], items: [
            {
                label: t("tableManagement.moreInfoDrawer.detail.tableInfo"),
                key: "tableInfo",
                children: _jsx(AtomList, { items: tableInfoItems() }),
            },
        ] }));
};
export default TableInfo;
